import { render, staticRenderFns } from "./ApplicationCommunicationList.vue?vue&type=template&id=ad277bb8&scoped=true&"
import script from "./ApplicationCommunicationList.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCommunicationList.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationCommunicationList.vue?vue&type=style&index=0&id=ad277bb8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad277bb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad277bb8')) {
      api.createRecord('ad277bb8', component.options)
    } else {
      api.reload('ad277bb8', component.options)
    }
    module.hot.accept("./ApplicationCommunicationList.vue?vue&type=template&id=ad277bb8&scoped=true&", function () {
      api.rerender('ad277bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/applicationCommunication/ApplicationCommunicationList.vue"
export default component.exports